var map = {
	"./auth.js": "889e",
	"./holderexport.js": "e89f",
	"./holderlist.js": "1640",
	"./index.js": "4360",
	"./insuranceexport.js": "df55",
	"./insurancelist.js": "8047"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "89d3";